import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { updateEventConnection, createEventConnection } from '@/redux/actions';

const WS_EVENTS_BY_HTTP = {
	CREATE: 'event/:eventID/connection/POST',
	DELETE: 'event/:eventID/connection/:connectionID/DELETE',
	UPDATE: 'event/:eventID/connection/:connectionID/PATCH',
};

const EventConnectionSubscriptions = props => {
	const {
		socket,
		children,
		currentEventId,
		connections,
		updateEventConnection,
		createEventConnection,
	} = props;

	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToConnections = () => {
		socket.emit('event/:eventID/connection/SUBSCRIBE', { eventID: currentEventId });
		console.log('⚡️ EventConnectionSubscriptions Mounted ⚡️', connections);
	};

	const unsubscribeToConnections = () => {
		socket.emit('event/:eventID/connection/UNSUBSCRIBE', { eventID: currentEventId });
		console.log(`🚶‍♂️ EventConnectionSubscriptions Unmounted 🚶‍♂️`, connections);
	};

	const listenForUpdatedEventConnection = () =>
		socket.on(WS_EVENTS_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error updating event connection', error);
			else {
				updateEventConnection(data);
				displayMessage('Event Connection Updated');
			}
		});

	const listenForCreatedEventConnection = () =>
		socket.on(WS_EVENTS_BY_HTTP.CREATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error Creating Event Connection', error);
			else {
				createEventConnection(data);
				displayMessage('Event Connection created');
			}
		});

	const listeners = () => [listenForCreatedEventConnection, listenForUpdatedEventConnection];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToConnections}
				unsub={unsubscribeToConnections}
				listeners={listeners()}
				routes={Object.values(WS_EVENTS_BY_HTTP)}
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	updateEventConnection: eventConnection => dispatch(updateEventConnection(eventConnection)),
	createEventConnection: eventConnection => dispatch(createEventConnection(eventConnection)),
});

export default connect(msp, mdp)(EventConnectionSubscriptions);
